export const highlightText = (text, term, isEnabled = true) => {
  // Handle null, undefined, and non-enabled cases
  if (!isEnabled) return text;
  if (text === null || text === undefined) return '';
  if (!term) return text;
  
  // Handle term being an object (like in geneFilters)
  const searchTerm = typeof term === 'object' && term?.term ? term.term : term;
  if (!searchTerm) return text;
  
  try {
    // Convert text to string if it's not already
    const textStr = String(text);
    const termStr = String(searchTerm);
    
    // If empty strings, just return the original
    if (!textStr.trim() || !termStr.trim()) return text;
    
    // Escape special regex characters
    const escapeRegExp = (string) => {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };
  
    const escapedTerm = escapeRegExp(termStr);
    const regex = new RegExp(`(${escapedTerm})`, 'gi');
    
    // Test if there's actually a match before splitting
    if (!regex.test(textStr)) return text;
    
    // Reset regex lastIndex
    regex.lastIndex = 0;
    
    const parts = textStr.split(regex);
  
    return (
      <span>
        {parts.map((part, i) => {
          // More reliable test for match than regex.test which depends on lastIndex
          const isMatch = part.toLowerCase() === termStr.toLowerCase();
          return isMatch ? (
            <span key={i} className="bg-blue-100 text-blue-900 px-0.5 rounded font-medium">
              {part}
            </span>
          ) : (
            <span key={i}>{part}</span>
          );
        })}
      </span>
    );
  } catch (error) {
    console.error('Error in highlightText:', error);
    return text; // Return original text if any error occurs
  }
};